import React, { Component } from 'react';
import { Alert, Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { withCookies } from 'react-cookie';
import { inject, observer } from 'mobx-react';
import ControlledInput from 'components/shared/controlled-input';
import humanize from 'utils/humanize';
import actions from 'api/actions';
import RootModelStore from 'stores/root-model-store';
import _ from 'lodash';

const formFields = [
  'license_key',
  'first_name',
  'last_name',
  'email',
  'password',
];

const ConnectedRegisterForm = withCookies(
  inject(
    'sessionStore',
    'routing',
  )(
    observer(
      class RegisterForm extends Component {
        state = {};

        handleChange(e) {
          const name = e.target.name;
          const val = e.target.value;
          this.setState({ [name]: val });
        }

        handleSubmit(e) {
          e.preventDefault();
          const data = {};
          if (formFields.some(field => !this.state[field])) {
            this.setState({ error: 'Please make sure all fields are filled' });
            return;
          }

          formFields.forEach(field => (data[field] = this.state[field]));

          actions
            .create('sign_up', { user: data })
            .then(r => {
              this.props.sessionStore.login(
                { ...r.data, email: data.email },
                this.props.cookies,
              );
              _.forEach(RootModelStore.stores, store => {
                store.reset();
              });
              this.props.routing.push('/');
            })
            .catch(e => {
              this.setState({ ...this.state, error: e.response.data.error });
            });
        }

        createInputs() {
          return formFields.map(key => (
            <div key={key} className="form-group">
              <label htmlFor={key}>{humanize(key)}</label>
              <ControlledInput
                name={key}
                type={key === 'password' ? 'password' : 'text'}
                value={this.state[key] || ''}
                onChange={this.handleChange.bind(this)}
              />
            </div>
          ));
        }

        dismissError() {
          this.setState({ ...this.state, error: null });
        }

        render() {
          const { error } = this.state;
          return (
            <Row>
              <Col md={6} className="offset-md-3">
                <p>&nbsp;</p>
                <Card className="register-panel">
                  <CardHeader>
                    <h2 className="m-0">Register</h2>
                  </CardHeader>
                  <CardBody>
                    <Alert
                      isOpen={!!error}
                      color="danger"
                      toggle={this.dismissError.bind(this)}
                    >
                      {error}
                    </Alert>
                    <form>
                      {this.createInputs()}
                      <button
                        className="btn btn-primary"
                        onClick={this.handleSubmit.bind(this)}
                      >
                        Register
                      </button>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        }
      },
    ),
  ),
);

export default ConnectedRegisterForm;
